module.exports = __webpack_public_path__ + "img/socialMediaLinkedinNavy.e2b4be76.png";